(function () {
    document.querySelectorAll('[data-range-dual]').forEach(root => {
        const min = root.querySelector('input[data-min]');
        const max = root.querySelector('input[data-max]');
        const fill = root.querySelector('.range-dual__fill');
        const outMin = root.querySelector('[data-out-min]');
        const outMax = root.querySelector('[data-out-max]');
        const minGap = Number(root.getAttribute('data-gap') || 0);

        function clamp() {
            let vMin = Math.min(Number(min.value), Number(max.value));
            let vMax = Math.max(Number(min.value), Number(max.value));
            if (vMax - vMin < minGap) {
                if (this === min) vMin = vMax - minGap; else vMax = vMin + minGap;
            }
            min.value = vMin;
            max.value = vMax;
        }

        function paint() {
            const lo = Number(min.min), hi = Number(min.max);
            const a = (Number(min.value) - lo) / (hi - lo) * 100;
            const b = (Number(max.value) - lo) / (hi - lo) * 100;
            fill.style.left = a + '%';
            fill.style.right = (100 - b) + '%';
            if (outMin) outMin.textContent = min.value;
            if (outMax) outMax.textContent = max.value;
        }

        ['input', 'change'].forEach(evt => {
            min.addEventListener(evt, function () {
                clamp.call(min);
                paint();
            });
            max.addEventListener(evt, function () {
                clamp.call(max);
                paint();
            });
        });

        // init
        paint();
    });
})();
